import { Component, OnInit, Input, ChangeDetectorRef, } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
// const sign = require('jwt-encode');
// import { copyBlobToClipboard } from 'copy-image-clipboard';
import { LocalSaveService } from '../../services/local-save-service.service';
import { AppServiceService } from '../../services/app-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-manejo-consentimiento',
  templateUrl: './manejo-consentimiento.component.html',
  styleUrls: ['./manejo-consentimiento.component.scss']
})
export class ManejoConsentimientoComponent implements OnInit {

  @Input() token: number;
  @Input() phone: number;

  public showOptions: boolean = false;
  public sanitizeurl;

  constructor(
    public _sanitizer: DomSanitizer,
    public localsave: LocalSaveService,
    public appservice: AppServiceService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    let url = environment.consentimientoBaseUrl + '/embebed?token='+
    this.token +
    '&showHeader=false'+
    '&showFooter=false';
    this.sanitizeurl = this._sanitizer.bypassSecurityTrustResourceUrl(url);
  }

}
